import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "shadow sm:rounded-md sm:overflow-hidden mb-4" }
const _hoisted_6 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { id: "store-status-label" }
const _hoisted_9 = { class: "tooltip" }

import { reactive } from 'vue'
import { useRouter } from 'vue-router'

import { useToast } from '@/composables/useToast'
import { planLimitError } from '@/helpers/planLimits'
import api from '@/store/api'


export default {
  __name: 'StoreNew',
  setup(__props) {

const router = useRouter()
const { showToast } = useToast()

// Store
const store = reactive({
  name: '',
  description: '',
  status: 'live',
  isPublic: true
})

const storeStatusString = () => {
  return `Store status: ${store.isPublic ? 'Public' : 'Draft'}`
}

// Actions
const handleSubmit = () => {
  api
    .call('POST', 'stores', {
      store: {
        store_name: store.name,
        store_description: store.description,
        status: 'live',
        is_public: store.isPublic
      }
    })
    .then(response => {
      router.push('/store/stores/' + response.data.data.id)
    })
    .catch(error => {
      const message = planLimitError(error)
      if (!message) throw error
      showToast(message, { type: 'error' })
    })
}

const handleKeydown = event => {
  // 'Enter' outside textarea
  if (event.keyCode === 13 && event.target.localName !== 'textarea') event.preventDefault()
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_BasicContainer = _resolveComponent("BasicContainer")
  const _component_MainCol = _resolveComponent("MainCol")
  const _component_SideCol = _resolveComponent("SideCol")
  const _component_PageGrid = _resolveComponent("PageGrid")
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: store.name || 'New store'
      }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "flex flex-1 flex-col justify-between",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers($event => (handleSubmit()), ["prevent"])),
          onKeydown: [
            _cache[4] || (_cache[4] = _withKeys($event => (handleKeydown($event)), ["enter"])),
            _cache[5] || (_cache[5] = _withKeys(_withModifiers($event => (handleSubmit()), ["meta","exact"]), ["enter"]))
          ]
        }, [
          _createVNode(_component_PageGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_MainCol, null, {
                default: _withCtx(() => [
                  _createVNode(_component_BasicContainer, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[6] || (_cache[6] = _createElementVNode("label", {
                            for: "store-title",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "Title", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "store-title",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((store.name) = $event)),
                            type: "text",
                            name: "store-title",
                            class: "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                          }, null, 512), [
                            [_vModelText, store.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", {
                            for: "store-description",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, " Description ", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            id: "store-description",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((store.description) = $event)),
                            name: "store-description",
                            rows: "8",
                            class: "shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, store.description]
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_SideCol, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createTextVNode(_toDisplayString(storeStatusString()) + " ", 1),
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "tooltiptext" }, " Set to public when you're ready to accept orders for this store. ", -1))
                          ])
                        ]),
                        _createElementVNode("button", {
                          id: "newLimit",
                          name: "newLimit",
                          class: _normalizeClass([
                        `mt-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`,
                        store.isPublic ? 'bg-blue-600' : 'bg-gray-200'
                      ]),
                          type: "button",
                          role: "switch",
                          "aria-labelledby": "newLimit",
                          onClick: _cache[2] || (_cache[2] = $event => (store.isPublic ? (store.isPublic = false) : (store.isPublic = true)))
                        }, [
                          _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: _normalizeClass([
                          `pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`,
                          store.isPublic ? 'translate-x-5' : 'translate-x-0'
                        ])
                          }, null, 2)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_PageFooter, null, {
            left: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "btn-ghost",
                to: "/store/stores"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              })
            ]),
            right: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("button", {
                class: "btn-primary",
                type: "submit"
              }, "Save", -1)
            ]))]),
            _: 1
          })
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

}